/**   
 * 商品管理api
 */
export default {
  selectProductList: "/productInfo/selectProductList",    // 商品库列表
  updateSaleStatus: "/productInfo/updateSaleStatus",    // 批量上下架
  selectProductDetail: "/productInfo/selectProductDetail",    // 商品详情
  saveProductInfo: "/productInfo/save",    // 上传新商品
  updateProductInfo: "/productInfo/update",    // 编辑商品
  deleteProduct: "/productInfo/delete",    // 删除
  importNewProductApply: "/productInfo/importNewProductApply",    // 批量导入

  /* 商品分类 */
  getCategoryList: "/productCategory/list",    // 分类列表
  newAddCategory: "/productCategory/newAdd",    // 新增分类
  newUpdateCategory: "/productCategory/newUpdate",    // 修改分类
  newDeleteCategory: "/productCategory/newDelete",    // 删除分类

  /**
   * 费用设置
   */
  getShopFeeSetList: "/storeFeeSet/list",  // 列表
  updateShopFeeAmount: "/storeFeeSet/updateShopFeeAmount",   // 修改金额
  updateShopFeeStatus: "/storeFeeSet/updateShopFeeStatus",   // 修改状态
  
   
};